import React, { Fragment, useState, useEffect } from "react";
import MENUITEMS, { IMainMenu, MainMenu, MenuItem } from "../../configs/menu";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, Grid } from "react-feather";
import { FormattedMessage } from "react-intl";
import { useAuth } from "../../hooks/auth";
import { useSelector } from "react-redux";
import { ICombineReducers } from "../../redux";
import configDB from "../../configs/theme";

// import siteLogo from "../../assets/images/logo/logo.png";
// import siteLogoDark from "../../assets/images/logo/logo_dark.png";
// import siteLogoFavicon from "../../assets/images/logo/logo-icon.png";

import siteLogo from "../../assets/images/logo/logo_stark.png";
import siteLogoDark from "../../assets/images/logo/logo_dark_stark.png";
import siteLogoFavicon from "../../assets/images/logo/logo-icon-stark.png";

import { SITE_TITLE } from "../../configs/constants";

const Sidebar: React.FC = (props) => {
  const [mainmenu, setMainMenu] = useState<IMainMenu>({ mainmenu: MENUITEMS });
  const [margin, setMargin] = useState<number>(0);
  const [width, setWidth] = useState<number>(0);
  const [sidebartoogle, setSidebartoogle] = useState<boolean>(true);
  const wrapper =
    useSelector<ICombineReducers>(
      (content) => content.Customizer.sidebar_types.type
    ) || configDB.data.settings.sidebar.type;
  const { hasScopes, hasAnyScopes } = useAuth();

  useEffect(() => {
    document.querySelector(".left-arrow").classList.add("d-none");

    window.addEventListener("resize", handleResize);
    handleResize();

    const currentUrl = window.location.pathname;
    mainmenu.mainmenu.map((items) => {
      items.items.filter((Items) => {
        if (Items.path === currentUrl) setNavActive(Items);
        if (!Items.children) return false;
        Items.children.filter((subItems) => {
          if (subItems.path === currentUrl) setNavActive(subItems);
          if (!subItems.children) return false;
          subItems.children.filter((subSubItems) => {
            if (subSubItems.path === currentUrl) {
              setNavActive(subSubItems);
              return true;
            } else {
              return false;
            }
          });
          return subItems;
        });
        return Items;
      });
      return items;
    });

    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line
  }, []);

  const handleResize = () => {
    setWidth(window.innerWidth - 500);
  };

  const setNavActive = (item: MenuItem) => {
    MENUITEMS.map((menuItems) => {
      menuItems.items.filter((Items) => {
        if (Items !== item) Items.active = false;
        if (Items.children && Items.children.includes(item))
          Items.active = true;
        if (Items.children) {
          Items.children.filter((submenuItems) => {
            if (submenuItems.children && submenuItems.children.includes(item)) {
              Items.active = true;
              submenuItems.active = true;
              return true;
            } else {
              return false;
            }
          });
        }
        return Items;
      });
      return menuItems;
    });
    item.active = !item.active;
    setMainMenu({ mainmenu: MENUITEMS });
  };

  const toggletNavActive = (item: MenuItem) => {
    if (window.innerWidth <= 991) {
      document.querySelector(".page-header").className = "page-header close_icon";
      document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper close_icon "
      document.querySelector(".mega-menu-container")?.classList?.remove("d-block")
      if (item.type === "sub") {
        document.querySelector(".page-header").className = "page-header ";
        document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper "
      }
    }

    if (!item.active) {
      MENUITEMS.map((a) => {
        a.items.filter((Items) => {
          if (a.items.includes(item)) Items.active = false;
          if (!Items.children) return false;
          Items.children.forEach((b) => {
            if (Items.children.includes(item)) {
              b.active = false;
            }
            if (!b.children) return false;
            b.children.forEach((c) => {
              if (b.children.includes(item)) {
                c.active = false;
              }
            });
          });
          return Items;
        });
        return a;
      });
    }
    item.active = !item.active;
    setMainMenu({ mainmenu: MENUITEMS });
  };

  const scrollToRight = () => {
    if (margin <= -2598 || margin <= -2034) {
      if (width === 492) {
        setMargin(-3570);
      } else {
        setMargin(-3464);
      }
      document.querySelector(".right-arrow").classList.add("d-none");
      document.querySelector(".left-arrow").classList.remove("d-none");
    } else {
      setMargin((margin) => (margin += -width));
      document.querySelector(".left-arrow").classList.remove("d-none");
    }
  };

  const scrollToLeft = () => {
    if (margin >= -width) {
      setMargin(0);
      document.querySelector(".left-arrow").classList.add("d-none");
      document.querySelector(".right-arrow").classList.remove("d-none");
    } else {
      setMargin((margin) => (margin += width));
      document.querySelector(".right-arrow").classList.remove("d-none");
    }
  };

  const openCloseSidebar = (toggle: boolean) => {
    if (toggle) {
      setSidebartoogle(!toggle);
      document.querySelector(".page-header").className = "page-header close_icon";
      document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper close_icon "
    } else {
      setSidebartoogle(!toggle);
      document.querySelector(".page-header").className = "page-header";
      document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper "
    }
  };

  const responsiveSidebar = () => {
    document.querySelector(".page-header").className = "page-header close_icon";
    document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper close_icon"
  };

  return (
    <Fragment>
      <div className="sidebar-wrapper">
        <div className="logo-wrapper">
          <Link to="#javascript">
            <img
              className="img-fluid for-light"
              src={siteLogo}
              alt={SITE_TITLE}
            />
            <img
              className="img-fluid for-dark"
              src={siteLogoDark}
              alt={SITE_TITLE}
            />
            <div className="back-btn" onClick={() => responsiveSidebar()}>
              <i className="fa fa-angle-left"></i>
            </div>
          </Link>
          <div
            className="toggle-sidebar"
            onClick={() => openCloseSidebar(sidebartoogle)}
          >
            <Grid className="status_toggle middle sidebar-toggle" />
          </div>
        </div>
        <div className="logo-icon-wrapper">
          <Link to="#javascript">
            <img
              className="img-fluid"
              src={siteLogoFavicon}
              alt={SITE_TITLE}
            />
          </Link>
        </div>
        <nav className="sidebar-main">
          <div className="left-arrow" onClick={scrollToLeft}>
            <ArrowLeft />
          </div>
          <div id="sidebar-menu" style={wrapper === 'horizontal-wrapper' ? { 'marginLeft': margin + 'px' } : { margin: '0px' }}>
            <ul className="sidebar-links custom-scrollbar">
              <li className="back-btn">
                <div className="mobile-back text-right">
                  <span>
                    <FormattedMessage id="general.back" />
                  </span>
                  <i
                    className="fa fa-angle-right pl-2"
                    aria-hidden="true"
                  ></i>
                </div>
              </li>
              {mainmenu.mainmenu.map((Item: MainMenu, i: number) => {
                if (
                  !Item.scopes ||
                  (Item.scopes && hasAnyScopes(Item.scopes))
                ) {
                  return (
                    <Fragment key={i}>
                      <li className="sidebar-main-title">
                        <div>
                          <h6 className="lan-1">
                            <FormattedMessage id={Item.menuTitle} />
                          </h6>
                          <p className="lan-2">
                            <FormattedMessage id={Item.menuContent} />
                          </p>
                        </div>
                      </li>
                      {Item.items.map((menuItem, i) => {
                        if (
                          !menuItem.scopes ||
                          (menuItem.scopes && hasAnyScopes(menuItem.scopes))
                        ) {
                          return (
                            <li className="sidebar-list" key={i}>
                              {menuItem.type === "sub" ? (
                                <a
                                  className={`sidebar-link sidebar-title ${menuItem.active ? "active" : ""
                                    } ${menuItem.hidden ? "hidden" : ""}`}
                                  href="#javascript"
                                  onClick={() => setNavActive(menuItem)}
                                >
                                  <menuItem.icon />
                                  <span>
                                    <FormattedMessage id={menuItem.title} />
                                  </span>
                                  {menuItem.badge ? (
                                    <label className={menuItem.badge}>
                                      {menuItem.badgeTxt}
                                    </label>
                                  ) : (
                                      ""
                                    )}
                                  <div className="according-menu">
                                    {menuItem.active ? (
                                      <i className="fa fa-angle-down"></i>
                                    ) : (
                                        <i className="fa fa-angle-right"></i>
                                      )}
                                  </div>
                                </a>
                              ) : (
                                  ""
                                )}

                              {menuItem.type === "link" ? (
                                <Link
                                  to={menuItem.path}
                                  className={`sidebar-link sidebar-title link-nav ${menuItem.active ? "active" : ""
                                    } ${menuItem.hidden ? "hidden" : ""}`}
                                  href="#javascript"
                                  onClick={() => toggletNavActive(menuItem)}
                                >
                                  <menuItem.icon />
                                  <span>
                                    <FormattedMessage id={menuItem.title} />
                                  </span>
                                  {menuItem.badge ? (
                                    <label className={menuItem.badge}>
                                      {menuItem.badgeTxt}
                                    </label>
                                  ) : (
                                      ""
                                    )}
                                </Link>
                              ) : (
                                  ""
                                )}

                              {menuItem.children ? (
                                <ul className="sidebar-submenu"
                                  style={menuItem.active ? sidebartoogle ? { opacity: 1, transition: 'opacity 500ms ease-in' } : { display: "block" } : { display: "none" }}>
                                  {menuItem.children.map(
                                    (childrenItem, index) => {
                                      if (
                                        !childrenItem.scopes ||
                                        (childrenItem.scopes &&
                                          hasScopes(childrenItem.scopes))
                                      ) {
                                        return (
                                          <li key={index}>
                                            {childrenItem.type === "sub" ? (
                                              <a
                                                className={`${childrenItem.active
                                                  ? "active"
                                                  : ""
                                                  } ${childrenItem.hidden
                                                    ? "hidden"
                                                    : ""
                                                  }`}
                                                href="#javascript"
                                                onClick={() =>
                                                  toggletNavActive(
                                                    childrenItem
                                                  )
                                                }
                                              >
                                                <FormattedMessage
                                                  id={childrenItem.title}
                                                />
                                                <span className="sub-arrow">
                                                  <i className="fa fa-chevron-right"></i>
                                                </span>
                                                <div className="according-menu">
                                                  {childrenItem.active ? (
                                                    <i className="fa fa-angle-down"></i>
                                                  ) : (
                                                      <i className="fa fa-angle-right"></i>
                                                    )}
                                                </div>
                                              </a>
                                            ) : (
                                                ""
                                              )}

                                            {childrenItem.type === "link" ? (
                                              <Link
                                                to={childrenItem.path}
                                                className={`${childrenItem.active
                                                  ? "active"
                                                  : ""
                                                  } ${childrenItem.hidden
                                                    ? "hidden"
                                                    : ""
                                                  }`}
                                                onClick={() =>
                                                  toggletNavActive(
                                                    childrenItem
                                                  )
                                                }
                                              >
                                                <FormattedMessage
                                                  id={childrenItem.title}
                                                />
                                              </Link>
                                            ) : (
                                                ""
                                              )}

                                            {childrenItem.children ? (
                                              <ul className="nav-sub-childmenu submenu-content"
                                                style={childrenItem.active ? { display: "block" } : { display: "none" }}
                                              >
                                                {childrenItem.children.map(
                                                  (childrenSubItem, key) => {
                                                    if (
                                                      !childrenSubItem.scopes ||
                                                      (childrenSubItem.scopes &&
                                                        hasScopes(
                                                          childrenSubItem.scopes
                                                        ))
                                                    ) {
                                                      return (
                                                        <li key={key}>
                                                          {childrenSubItem.type ===
                                                            "link" ? (
                                                              <Link
                                                                to={
                                                                  childrenSubItem.path
                                                                }
                                                                className={`${childrenSubItem.active
                                                                  ? "active"
                                                                  : ""
                                                                  } ${childrenSubItem.hidden
                                                                    ? "hidden"
                                                                    : ""
                                                                  }`}
                                                                onClick={() =>
                                                                  toggletNavActive(
                                                                    childrenSubItem
                                                                  )
                                                                }
                                                              >
                                                                <FormattedMessage
                                                                  id={
                                                                    childrenSubItem.title
                                                                  }
                                                                />
                                                              </Link>
                                                            ) : (
                                                              ""
                                                            )}
                                                        </li>
                                                      );
                                                    }
                                                    return "";
                                                  }
                                                )}
                                              </ul>
                                            ) : (
                                                ""
                                              )}
                                          </li>
                                        );
                                      }
                                      return "";
                                    }
                                  )}
                                </ul>
                              ) : (
                                  ""
                                )}
                            </li>
                          );
                        }
                        return "";
                      })}
                    </Fragment>
                  );
                }
                return "";
              })}
            </ul>
          </div>
          <div className="right-arrow" onClick={scrollToRight}>
            <ArrowRight />
          </div>
        </nav>
      </div>
    </Fragment>
  );
};

export default Sidebar;
